import { roundToPlaces } from "../../utils/roundToPlaces.js";
import { type TaxLevel, taxLevelValueMap } from "../TaxLevel.js";

export function calculatePriceWithoutTax(priceWithTax: number, taxLevel: TaxLevel): number {
	const taxCoefficient = 1 + taxLevelValueMap[taxLevel] / 100;
	const withoutTax = priceWithTax / taxCoefficient;
	return roundToPlaces(withoutTax, 2);
}
